// extracted by mini-css-extract-plugin
export default {"view-recreate-modal":"ViewRecreateModal_view-recreate-modal__ZY9DH"};